import { AnyAction } from 'redux';
import {
  OVERLAY_ADD_OVERLAY,
  OVERLAY_CLOSE_OVERLAY,
  OVERLAY_REMOVE_OVERLAY,
  OVERLAY_UPDATE_OVERLAY,
} from '../constants';

interface OverlayComponent {
  name: string;
  onOverlayClick: () => boolean;
}

interface OverlayState {
  activeOverlays: OverlayComponent[];
  disableOverlayClick?: boolean;
}

const DEFAULT_STATE: OverlayState = {
  activeOverlays: [],
};

export const overlay = (
  state = DEFAULT_STATE,
  action: AnyAction
): OverlayState => {
  let activeOverlays: OverlayComponent[] = Object.assign(
    [],
    state.activeOverlays
  );
  switch (action.type) {
    case OVERLAY_ADD_OVERLAY:
      if (
        activeOverlays.findIndex(
          (o) => o.name == action.payload.componentName
        ) == -1
      ) {
        activeOverlays.push({
          name: action.payload.componentName,
          onOverlayClick: action.payload.onOverlayClick,
        });
      }

      return {
        ...state,
        activeOverlays,
      };

    case OVERLAY_UPDATE_OVERLAY:
      const activeOverlay = activeOverlays.find(
        (o) => o.name == action.payload.componentName
      );
      if (activeOverlay) {
        activeOverlay.name = action.payload.componentName;
        activeOverlay.onOverlayClick = action.payload.onOverlayClick;
      }

      return {
        ...state,
        activeOverlays,
      };

    case OVERLAY_REMOVE_OVERLAY:
      let index = activeOverlays.findIndex(
        (c) => c.name == action.payload.componentName
      );
      if (index != -1) {
        activeOverlays.splice(index, 1);
      }

      return {
        ...state,
        activeOverlays,
      };

    case OVERLAY_CLOSE_OVERLAY:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
